import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { RenderMenuNode } from 'src/app/core/state-mangement/side-menu/menu.types';
import { SideMenuQuery } from 'src/app/core/state-mangement/side-menu/side-menu.query';
import { SessionService } from 'src/app/core/state-mangement/session/session.service';
import { MenuController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent implements OnInit, OnDestroy {
  @Input() requestedAbsences: number | null = null;
  @Input() loggedIn: boolean | null = null;

  tree$: Observable<RenderMenuNode[]> = this.query.tree$;

  /** Exklusives Root-Akkordeon: welcher Root-Key ist offen */
  expandedRootKey: string | null = null;

  private destroy$ = new Subject<void>();

  constructor(
    private query: SideMenuQuery,
    private sessionService: SessionService,
    private menuCtrl: MenuController,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  async onParentClick(p: RenderMenuNode) {
    if (!p.route || p.disabled) return;
    await this.router.navigate([p.route]).catch(() => {});
    try {
      await this.menuCtrl.close();
    } catch {}
  }

  async onChildParentClick(item: RenderMenuNode) {
    if (!item.route || item.disabled) return;
    await this.router.navigate([item.route]).catch(() => {});
    try {
      await this.menuCtrl.close();
    } catch {}
  }

  ngOnInit(): void {
    this.tree$
      .pipe(
        takeUntil(this.destroy$),
        map((roots) => roots ?? [])
      )
      .subscribe((roots) => {
        // 1) prefferred "personal" if it has children
        const preferred = roots.find(
          (r) => r.key === 'personal' && r.children?.length
        );
        // 2) else first element with children
        const firstWithChildren = roots.find((r) => r.children?.length);
        const desiredKey = preferred?.key ?? firstWithChildren?.key ?? null;

        // only set when changed
        if (this.expandedRootKey !== desiredKey) {
          this.expandedRootKey = desiredKey;
          this.cdr.markForCheck();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackByKey = (_: number, n: RenderMenuNode) => n.key;

  onRootOpened(key: string) {
    if (this.expandedRootKey !== key) {
      this.expandedRootKey = key;
      this.cdr.markForCheck();
    }
  }

  async logout() {
    this.sessionService.logout();

    try {
      await this.menuCtrl.close();
    } catch {}

    this.router.navigate(['/login']);
  }
}
